import { useQuery } from "@tanstack/react-query";
import {
	createPublicClient,
	erc20Abi,
	formatUnits,
	http,
} from "viem";
import { arbitrum } from "viem/chains";
import { queryKeys } from "./query-keys";
import { useWallet } from "./use-wallet";

const USDC_ADDRESS = "0xaf88d065e77c8cC2239327C5EDb3A432268e5831" as const;
const USDT_ADDRESS = "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9" as const;

const publicClient = createPublicClient({
	chain: arbitrum,
	transport: http(),
});


export function useWalletBalance() {
	const { address } = useWallet();

	const query = useQuery({
		queryKey: queryKeys.wallet.balances(address),
		queryFn: async () => {
			const addr = address as `0x${string}`;
			const [usdcRaw, usdtRaw] = await Promise.all([
				publicClient.readContract({
					address: USDC_ADDRESS,
					abi: erc20Abi,
					functionName: "balanceOf",
					args: [addr],
				}),
				publicClient.readContract({
					address: USDT_ADDRESS,
					abi: erc20Abi,
					functionName: "balanceOf",
					args: [addr],
				}),
			]);
			return {
				usdc: Number(formatUnits(usdcRaw, 6)),
				usdt: Number(formatUnits(usdtRaw, 6)),
			};
		},
		staleTime: 30_000,
		refetchInterval: 30_000,
		enabled: address !== null,
	});

	const usdc = query.data?.usdc ?? 0;
	const usdt = query.data?.usdt ?? 0;

	return {
		...query,
		balance: usdc,
		usdtBalance: usdt,
	};
}
